module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Ariel"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Jim Hale is a retired high school teacher who specialised in English literature. He taught for 40 years in country NSW and city schools, giving him an incredible range of life experiences. He wrote most of the poems included herein before he had a serious stroke and lost some of what he still wanted to write. He wrote the last eight poems while recovering from the stroke, though he does not recall writing them.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0